import React from 'react';
import '../styles/main.scss';
import { HealthDeclarationModel } from '../models/HealthDeclaration';

interface HealthDeclarationProps {
  data?: HealthDeclarationModel;
  onSubmit: (data: HealthDeclarationModel) => void;
  onBack: () => void;
}

class HealthDeclaration extends React.Component<HealthDeclarationProps, HealthDeclarationModel> {
  constructor(props: HealthDeclarationProps) {
    super(props);
    const defaultData = {
      hasPreExistingConditions: '',
      preExistingConditionDetails: '',
      isSmoker: '',
      isAlcoholConsumer: '',
      hasUndergoneSurgery: '',
      surgeryDetails: ''
    };
    this.state = props.data || defaultData;
  }

  handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const target = e.target;
    const value = target.type === 'checkbox' ? (target as HTMLInputElement).checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    } as any);
  };

  handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    this.props.onSubmit(this.state);
  };

  render() {
    const {
      hasPreExistingConditions,
      preExistingConditionDetails,
      isSmoker,
      isAlcoholConsumer,
      hasUndergoneSurgery,
      surgeryDetails
    } = this.state;

    return (
      <div className="registration-container">
        <h2 className="form-heading">આરોગ્ય ઘોષણા</h2>
        <form className="form-grid" onSubmit={this.handleSubmit}>
          
          <div>
            <label className="text-muted">શું તમને કોઈ ગંભીર બીમારી છે?</label>
            <select
              name="hasPreExistingConditions"
              value={hasPreExistingConditions}
              onChange={this.handleChange}
              required
              className="form-select"
            >
              <option value="">પસંદ કરો</option>
              <option value="yes">હા</option>
              <option value="no">ના</option>
            </select>
          </div>

          {hasPreExistingConditions === 'yes' && (
            <div>
              <label className="text-muted">બીમારીની વિગતો</label>
              <textarea
                name="preExistingConditionDetails"
                value={preExistingConditionDetails}
                onChange={this.handleChange}
                rows={3}
                placeholder="બીમારી વિશે જણાવો"
                required
              />
            </div>
          )}

          <div>
            <label className="text-muted">શું તમે ધૂમ્રપાન કરો છો?</label>
            <select
              name="isSmoker"
              value={isSmoker}
              onChange={this.handleChange}
              required
              className="form-select"
            >
              <option value="">પસંદ કરો</option>
              <option value="yes">હા</option>
              <option value="no">ના</option>
            </select>
          </div>

          <div>
            <label className="text-muted">શું તમે આલ્કોહોલનું સેવન કરો છો?</label>
            <select
              name="isAlcoholConsumer"
              value={isAlcoholConsumer}
              onChange={this.handleChange}
              required
              className="form-select"
            >
              <option value="">પસંદ કરો</option>
              <option value="yes">હા</option>
              <option value="no">ના</option>
            </select>
          </div>

          <div>
            <label className="text-muted">શું તમે કોઈ સર્જરી કરાવી છે?</label>
            <select
              name="hasUndergoneSurgery"
              value={hasUndergoneSurgery}
              onChange={this.handleChange}
              required
              className="form-select"
            >
              <option value="">પસંદ કરો</option>
              <option value="yes">હા</option>
              <option value="no">ના</option>
            </select>
          </div>

          {hasUndergoneSurgery === 'yes' && (
            <div>
              <label className="text-muted">સર્જરીની વિગતો</label>
              <textarea
                name="surgeryDetails"
                value={surgeryDetails}
                onChange={this.handleChange}
                rows={3}
                placeholder="સર્જરી વિશે જણાવો"
                required
              />
            </div>
          )}

          <div className="button-group">
            <button type="button" onClick={this.props.onBack} className="form-btn secondary">
              પાછા
            </button>
            <button type="submit" className="form-btn">
              આગળ વધો
            </button>
          </div>
        </form>
      </div>
    );
  }
}

export default HealthDeclaration;